import React from 'react';
import { Component } from 'react';
import { localizeUrl } from '@tesla/parse-locale';
import CarSelection from '../contents/carselection/CarSelection.js';
import { InitialState } from '../data/initialState';
import { connect } from 'react-redux';
import Header from './Header';
import { linkPlaceholder, getLocale } from '../utils/TranslationUtils';

class CarSelectionContain extends Component {
    constructor(props) {
        super(props);
        const { models } = props;

        this.setModel(models[0]);
    }

    setModel(val) {
        this._model = val;
    }

    getModel(val) {
        return this._model;
    }

    handleSubmit(e) {
        let { handleSubmit, handleSelection } = this.props;

        if (window.dataLayer) {
            window.dataLayer.push({
                event: 'form-interaction',
                interaction: 'vehicle-model-selected',
                formType: 'Test Drive',
                engagementType: 'User Requested'
            });
        }

        handleSelection(this.getModel());
        handleSubmit(e);
    }

    render() {
        const { containerClass, locale } = this.props;
        const carSelection = (typeof window.tesla !== "undefined") ? window.tesla.App.strings['Test_Drive/All'].content.carSelection : {};

        return (
            <div className={'content-container car-container ' + containerClass}>
                <Header 
                    title={carSelection.title}
                    paragraphs={[linkPlaceholder(
                        carSelection.title2,
                        { LEARN_MORE: carSelection.title2Lbl },
                        localizeUrl('/support/test-drive', {
                            locale,
                        }),
                    )]} />
                <CarSelection setModel={this.setModel.bind(this)} />
                <div className='btn-container'>
                    <button className="tds-btn tds-btn--blue" data-section="carSection" onClick={this.handleSubmit.bind(this)} id="edit-submit-td-ajax-2">{carSelection.next}</button>
                </div>
            </div>
        );
    }
}

CarSelectionContain.defaultProps = InitialState().carSection

export default connect(({ flags, carSection }) => ({
    containerClass: carSection.containerClass,
    locale: getLocale(),
    models: flags.availableModels,
}))(CarSelectionContain);



